// 카카오 계열 CP 코드
export const KAKAOTV_NO_LIVE = '0kakaotv';
export const KAKAOTV_OPEN    = 'kakaotvO';
export const DAUM_CAFE       = '0000cafe';
export const TISTORY         = '0tistory';
export const DAUM_BLOG       = 'daumblog';

// 그외 제휴, 유튜브 등
export const YOUTUBE    = '7b479cb3';
export const NAVER_BLOG = '2d1cf605';
export const ETC        = '7b9fecb6';
export const YOUTUBE_CHANNEL_ID = '1963';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/cp-meta/cp.js
 **/